import ClipsPublicRoutes from '@/views/saved-clips/routes-public';
import FaceEnrollmentPublicRoutes from '@/views/face-enrollment/routes-public';
import { CONFIG_ROUTES } from '@/config/routes';

export default [
  {
    path: '/',
    meta: {
      public: true
    },
    components: {
      default: () => import(/* webpackChunkName: "public-layout" */ '@/views/layouts/public/PublicLayout.vue')
    },
    children: [
      ...ClipsPublicRoutes,
      ...FaceEnrollmentPublicRoutes,

      // This route is considered "App Home"
      // If there are no URL params, direct to "home page".
      // We are purposefully NOT using the redirect query param here.
      {
        path: '',
        name: CONFIG_ROUTES.APP_HOME,
        beforeEnter(to, from, next) {
          return next({
            name: CONFIG_ROUTES.APP_HOME_REDIRECT
          });
        },
      },
    ]
  },
]
